import { type FormEvent, useState } from 'react';

interface AnswerFormProps {
  prompt: string;
  placeholder?: string;
  inputMode?: 'numeric' | 'text';
  secret?: boolean;
  onValidate: (answer: string) => Promise<boolean>;
  onSolved: (attempts: number) => void;
}

export function AnswerForm({ prompt, placeholder, inputMode = 'text', secret = false, onValidate, onSolved }: AnswerFormProps) {
  const [answer, setAnswer] = useState('');
  const [attempts, setAttempts] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [checking, setChecking] = useState(false);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    if (!answer.trim() || checking) return;
    const nextAttempts = attempts + 1;
    setAttempts(nextAttempts);
    setChecking(true);
    try {
      if (await onValidate(answer)) {
        setFeedback('¡Lo encontraste! 💫');
        window.setTimeout(() => onSolved(nextAttempts), 550);
      } else {
        setFeedback('Esa no es. Pensalo un poquito más.');
        setAnswer('');
      }
    } catch (reason) {
      setFeedback(reason instanceof Error ? reason.message : 'No se pudo validar la respuesta.');
    } finally { setChecking(false); }
  };

  return (
    <form className="answer-form" onSubmit={submit}>
      <p className="question">{prompt}</p>
      <input
        autoComplete="off"
        autoFocus
        className="text-input"
        disabled={checking}
        inputMode={inputMode}
        maxLength={500}
        onChange={(event) => setAnswer(event.target.value)}
        placeholder={placeholder || 'Tu respuesta…'}
        type={secret ? 'password' : 'text'}
        value={answer}
      />
      <button className="button button-primary" disabled={checking || !answer.trim()} type="submit">
        {checking ? 'Comprobando…' : 'Responder'}
      </button>
      <p className="feedback" aria-live="polite">{feedback}</p>
      <p className="attempts">Intentos: {attempts}</p>
    </form>
  );
}

